import { MainAPI } from './build/mainAPI';

export * from './build/mainAPI';
export default new MainAPI();
